const wx = window.wx

const shareConfig = {
  title: '上海同儒信息技术有限公司',
  desc: '国内专业的银行金融IT解决方案供应商，专注于金融行业软件产品的研发与实施',
  link: window.location.href,
  imgUrl: window.location.origin + '/logo60k.jpg'
}

export function setShareInfo(config) {
  Object.assign(shareConfig, config)
}

function doShare() {
  if (!wx) return
  wx.ready(function () {
    const shareData = {
      title: shareConfig.title,
      desc: shareConfig.desc,
      link: shareConfig.link,
      imgUrl: shareConfig.imgUrl,
      success: function () {},
      cancel: function () {}
    }
    wx.updateAppMessageShareData(shareData)
    wx.updateTimelineShareData(shareData)
  })

  wx.error(function (res) {
    console.log('wx config error:', res)
  })
}

export function initWxShare(options) {
  if (options) {
    Object.assign(shareConfig, options)
  }
  if (!wx) {
    console.warn('微信JS-SDK未加载')
    return
  }

  wx.config({
    debug: false,
    appId: '',
    timestamp: '',
    nonceStr: '',
    signature: '',
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData'
    ]
  })

  doShare()
}

export function getWxSignature(apiUrl) {
  return fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url: window.location.href.split('#')[0] })
  })
    .then(res => res.json())
    .then(data => {
      if (data.code === 0 && data.data) {
        wx.config({
          debug: false,
          appId: data.data.appId,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ]
        })
        doShare()
      }
    })
    .catch(err => {
      console.error('获取微信签名失败:', err)
    })
}